<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jyruaa/tc-custom/9781454931959.jpg?1702926878521" alt="This image is the cover for the book Lightning Strikes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lightning Strikes
      </h1>
      <p class="bookDescription body article font2">
        <b>An exploration of the scientist’s inspiring life, his controversies, his legacy, and how his creativity can help us today.</b><br/><br/>Seventy years after his death, Nikola Tesla has become a rock star. <i>Lightning Strikes</i> examines his complete life and legacy, including Tesla’s profound influence on everything from systems integration to drone warfare. Engineers, entrepreneurs, and academics will find it invaluable not only for the never-before-published interviews and archives, but also for the creative principles that visionaries like Larry Page and Elon Musk have used to build iconic brands and groundbreaking inventions. The book also reveals why the government and business leaders wanted to shut down Tesla’s bold experiments, and how hundreds of his ideas are now being implemented globally—including clean power, robotics, alternating current motors, and wireless transmission of power and information.<br/><br/>As a bonus, a free augmented reality app from Yetzer Studio allows you to scan beautiful full-color illustrations in the book, unlocking an interactive 3D animation as well as videos honoring Tesla's life and legacy.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John F. Wasik
      </h2>
      
      <p class="authorDescription body article">John Wasik—author of 15 books and more than 1,000 columns, blogs, and articles for the Wall Street Journal, The New York Times, Reuters, Forbes, and Bloomberg News—has been researching Tesla for more than a decade. He’s filed numerous Freedom of Information Act requests and reviewed thousands of pages of Tesla’s letters and files, many of which disappeared when he died in 1943. He has also consulted with Tesla experts worldwide and explored the vast resources of the Edison, JP Morgan, Westinghouse, and FBI archives. Wasik lives in Grayslake, IL, and speaks widely around the world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?389ecdfc